const BACKEND_URL = process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_BASE_URL 
    : process.env.REACT_APP_BACKEND_URL;

export { BACKEND_URL };
